// src/features/quests/questStepUtils.js

export function safeJsonParse(value) {
  if (!value) return null;
  if (typeof value === "object" && value !== null) return value;
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
}

export function getTargetRoomIdFromStep(step) {
  if (!step) return null;

  const meta = safeJsonParse(step.metadata);
  const target = meta?.targetRoomId || meta?.roomId;
  if (target) return target;

  const required = String(step.requiredEvent || "").trim();
  if (required.startsWith("NEW_ROOM_LOADING:")) {
    return required.split(":")[1] || null;
  }

  return null;
}

export function shouldCelebrate(step) {
  const meta = safeJsonParse(step?.metadata);
  return meta?.celebrate === true || meta?.celebrate === "true";
}

export function emitUnityCelebration(socket, userId) {
  if (!socket || !userId) return;
  const payload = { userId, payload: "PLAY_VFX:Celebrate" };
  socket.emit("system_message", JSON.stringify(payload));
}

export function emitUnityChangeRoom(socket, userId, targetRoomId) {
  if (!socket || !userId || !targetRoomId) return;
  const payload = { message: "changeRoom", userId, roomId: targetRoomId };
  socket.emit("system_message", JSON.stringify(payload));
}

export function openLinkoutAndNotifyUnity(socket, { url, roomId, userId }) {
  if (!url) return;

  let finalUrl = url;
  if (!/^https?:\/\//i.test(finalUrl)) finalUrl = `https://${finalUrl}`;

  window.open(finalUrl, "_blank");

  if (socket && userId && roomId) {
    const payload = {
      event: "",
      roomId,
      userId,
      payload: { OPEN_LINKOUT: finalUrl },
    };
    socket.emit("system_message", JSON.stringify(payload));
  }
}
